import React from "react";
import { useNavigate } from "react-router-dom";
import ExportButton from "@/components/ExportButton";
import { ArrowLeft, BarChart2, FileText, FileSpreadsheet } from "lucide-react";

// v1.29.45 — Outstanding Report moved off the Party Ledger nav bar into the
// Reports tab. Same underlying export endpoints; no logic change.
export default function OutstandingReport() {
    const navigate = useNavigate();
    return (
        <div className="mx-auto max-w-3xl px-4 py-6" data-testid="outstanding-report-page">
            <button
                type="button"
                onClick={() => navigate(-1)}
                data-testid="outstanding-back-btn"
                className="mb-4 inline-flex items-center gap-1.5 text-sm text-slate-600 transition hover:text-slate-900"
            >
                <ArrowLeft size={16} /> Back
            </button>
            <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-900 text-white">
                        <BarChart2 size={20} />
                    </div>
                    <div>
                        <h1 className="font-display text-xl font-bold text-slate-900">Outstanding Report</h1>
                        <p className="text-sm text-slate-600">Download the outstanding balances of all parties as PDF or Excel.</p>
                    </div>
                </div>
                <div className="mt-6">
                    <ExportButton
                        endpoint={{ pdf: "/export/outstanding.pdf", xlsx: "/export/outstanding.xlsx" }}
                        filenameBase="outstanding-report"
                        testId="report-outstanding-export"
                        label="Download Outstanding Report"
                        variant="primary"
                        pdfIcon={<FileText size={15} className="mr-2 text-red-600" />}
                        xlsxIcon={<FileSpreadsheet size={15} className="mr-2 text-emerald-600" />}
                    />
                </div>
            </div>
        </div>
    );
}
